import React from 'react'
import { withRouter } from 'react-router-dom'
import Dropzone from 'react-dropzone'
import {
  Menu,
  MenuDivider,
  MenuItem,
  Intent
} from '@blueprintjs/core'
import { Toast } from '../../Toaster'
import * as request from 'superagent'
import { blankCheques } from '../../firebase'
import { API_BASE_URL } from '../../index'

import './upload.css'

function cleanFile (file) {
  window.URL.revokeObjectURL(file.preview)
}

const sendEmail = (function () {
  let times = 0
  return function () {
    times += 1
    if (times > 1) { return 1 }
    request
      .post(API_BASE_URL + '/uploadCheque')
      .send({})
      .end()
  }
})()

function handleFile (file, cb = () => {}, fail = () => {}) {
  const name = file.name.split('.')
  const type = name[name.length - 1].toLowerCase()
  if (type !== 'pdf') {
    window.alert('Pdf files only!')
    cleanFile(file)
    return fail(file)
  } else {
    blankCheques
      .child(file.name)
      .put(file)
      .then(snapshot => {
        cleanFile(file)
        sendEmail()
        cb(file)
      }).catch((err) => {
        cleanFile(file)
        console.log(err)
        fail(file)
      })
  }
}

function onDrop (fileCB, acceptedFileCB, failedFileCB) {
  return function (acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach(file => {
      fileCB(file)
      handleFile(file, acceptedFileCB, failedFileCB)
    })
    rejectedFiles.forEach(file => {
      cleanFile(file)
      failedFileCB(file)
    })
  }
}

const renderMenuItem = (success, pending) =>
(file, key) => (
  <MenuItem key={key}
    intent={success
              ? Intent.SUCCESS
              : pending
                ? Intent.PRIMARY
                : Intent.DANGER
    }
    text={file.name}
    iconName={success
                ? 'endorsed'
                : pending
                  ? 'document'
                  : 'error'}
  />
)

const renderMenu = (files, uploaded, failed) => {
  files = files.filter(file => !uploaded.includes(file) && !failed.includes(file))

  return (
    <Menu>
      {
        files.length > 0 &&
        <div>
          <MenuDivider title='Pending' />
          { files.map(renderMenuItem(false, true)) }
        </div>
      }
      {
        uploaded.length > 0 &&
        <div>
          <MenuDivider title='Uploaded' />
          { uploaded.map(renderMenuItem(true)) }
        </div>
      }
      {
        failed.length > 0 &&
        <div>
          <MenuDivider title='Failed' />
          { failed.map(renderMenuItem(false)) }
        </div>
      }
    </Menu>
  )
}

const renderAlert = (state) => {
  const filesUploaded = state.files.length
  if (filesUploaded) {
    const filesProcessed = state.uploadedFiles.length + state.failedFiles.length
    if (filesProcessed === filesUploaded) {
      Toast.show({
        message: 'Finished Uploads',
        iconName: 'endorsed',
        intent: Intent.SUCCESS
      })
    }
  }
}

class Upload extends React.Component {
  constructor () {
    super()
    this.state = {
      files: [],
      uploadedFiles: [],
      failedFiles: []
    }
    this.fileCB = this.fileCB.bind(this)
    this.acceptedFileCB = this.acceptedFileCB.bind(this)
    this.failedFileCB = this.failedFileCB.bind(this)
  }

  componentWillMount () {
    const role = this.props.role
    if (!role || !role.incl.includes('bookkeeper')) {
      this.props.history.push('/dash/')
    }
  }

  fileCB (file) {
    let files = this.state.files
    files.push(file)
    this.setState({ files })
  }

  acceptedFileCB (file) {
    let uploadedFiles = this.state.uploadedFiles
    uploadedFiles.push(file)
    this.setState({ uploadedFiles })
  }

  failedFileCB (file) {
    let failedFiles = this.state.failedFiles
    failedFiles.push(file)
    this.setState({ failedFiles })
  }

  render () {
    return (
      <div className='upload-main'>
        {
          this.state.files.length > 0 &&
          <div className='pt-card upload-sidebar'>
            { renderMenu(this.state.files, this.state.uploadedFiles, this.state.failedFiles) }
          </div>
        }
        <div className='upload-body'>
          <div className='pt-card upload-dropzone-container'>
            <h4>Drop Blank Cheques Below</h4>
            <p>Or click to upload</p>
            <Dropzone
              className='upload-dropzone'
              activeClassName='upload-dropzone-hover'
              onDrop={onDrop(this.fileCB, this.acceptedFileCB, this.failedFileCB)}
            />
          </div>
        </div>
        {
          renderAlert(this.state)
        }
      </div>
    )
  }
}

export default withRouter(Upload)



// WEBPACK FOOTER //
// ./src/Private/Upload/Upload.js